module.exports = __webpack_public_path__ + "img/hyal-8.307bca59.png";